var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.flag && _vm.content)?_c('div',{class:_vm.classlist},[_c('p',[_vm._v(_vm._s(_vm.content))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }